import abi from './Transactions.json';
import MintTokenAbi from './MintToken.json';

export const contractAddress = '0x5FbDB2315678afecb367f032d93F642f64180aa3';
export const MintNFTAddress = '0xe7f1725E7734CE288F8367e1Bb143E90bb3F0512';
export const contractABI = abi.abi;
export const MintcontractABI = MintTokenAbi.abi;
